<h2 class="mat-title">Student Testing History</h2>
<table class="mat-table-styled bordered fullwidth">
    <thead>
        <tr class="mat-header-row-styled">
            <th class="mat-header-cell-styled width20 centered">Test Description</th>
            <th class="mat-header-cell-styled width20 centered">Year / Grade</th>
            <th class="mat-header-cell-styled width20 centered">Component</th>
            <th class="mat-header-cell-styled width20 centered">Test Date</th>
            <th class="mat-header-cell-styled width20 centered">Score</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let test of UIHistory; let $even = even">
            <ng-container *ngFor="let year of test.Years; let yidx = index">
                <ng-container *ngFor="let subj of year.Subjects; let sidx = index">
                    <ng-container *ngFor="let ex of subj.Exams; let eidx = index">
                        <tr class="mat-row-styled" [class.primarybackground50]="$even">
                            <td
                                *ngIf="yidx === 0 && sidx === 0 && eidx === 0"
                                class="mat-cell-styled centered"
                                [attr.rowspan]="test.RowSpan"
                            >
                                {{ test.TestDescription }}
                            </td>
                            <td *ngIf="sidx === 0 && eidx === 0" class="mat-cell-styled centered" [attr.rowspan]="year.RowSpan">
                                {{ year.SchoolYear | schoolYear }} (Grade {{ year.GradeLevel }})
                            </td>
                            <td *ngIf="eidx === 0" class="mat-cell-styled centered" [attr.rowspan]="subj.RowSpan">
                                {{ subj.Description }}
                            </td>
                            <td class="mat-cell-styled centered" [class.primarybackground200]="ex.PastThreshold">
                                {{ ex.TestDate | datefns: 'M/DD/YYYY' }}
                            </td>
                            <td class="mat-cell-styled centered" [class.primarybackground200]="ex.PastThreshold">
                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                                    <span>{{ ex.Score }}</span>
                                    <mat-icon *ngIf="ex.PastThreshold">check_circle</mat-icon>
                                    <mat-icon *ngIf="ex.Outdated">emoji_objects</mat-icon>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </tbody>
</table>
<div *ngIf="AnyMeeting || AnyOutdated" class="margin-top">
    <div *ngIf="AnyMeeting" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-icon>check_circle</mat-icon>
        <span>Meets eligibility in subject area.</span>
    </div>
    <div *ngIf="AnyOutdated" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-icon>emoji_objects</mat-icon>
        <span>Test is more than two (2) years old and ineligible for use in meeting subject area eligibility.</span>
    </div>
</div>

<!-- <mat-table class="bordered" #table [dataSource]="HistoryData">
    <ng-container matColumnDef="TestDescription">
        <mat-header-cell *matHeaderCellDef class="centered">Test Description</mat-header-cell>
        <mat-cell *matCellDef="let test" class="centered">{{test.Description}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Score">
        <mat-header-cell *matHeaderCellDef class="centered">Score</mat-header-cell>
        <mat-cell *matCellDef="let test" class="centered">{{test.Score}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="TestDate">
        <mat-header-cell *matHeaderCellDef class="centered">Test Date</mat-header-cell>
        <mat-cell *matCellDef="let test" class="centered">{{test.TestDate | datefns:'MM/DD/YYYY'}}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="['TestDescription', 'Score', 'TestDate']"></mat-header-row>
    <mat-row *matRowDef="let row; columns:['TestDescription', 'Score', 'TestDate'];let $even = even" [class.primarybackground50]="$even"></mat-row>
</mat-table> -->
<!-- Unused <tr ng-show="vm.SelectedStudent.TestHistory == null || vm.SelectedStudent.TestHistory.length == 0">
    <td colspan="3"><i>There are no test scores available for this student.</i></td>
</tr> -->



// WEBPACK FOOTER //
// ./src/app/ui/testhistory/testhistory.component.html